import React, { forwardRef, useRef, useImperativeHandle, useEffect } from 'react'
import UpOutlined from '@ant-design/icons/UpOutlined'
import DownOutlined from '@ant-design/icons/DownOutlined'
import classNames from 'classnames'

import styles from './index.less'

export default forwardRef(({ children, defaultFold, onCollapse, onHandle }, ref) => {
    const elRef = useRef(null)
    const subViewRef = useRef(null)

    useEffect(() => {
        if (typeof defaultFold !== 'boolean') {
            return
        }
        if (defaultFold) {
            fold()
        } else {
            expand()
        }
    }, [defaultFold])

    // 收起
    const fold = () => {
        if (!elRef.current) {
            return
        }

        elRef.current.classList.add(styles.hasCollapsed)
    }

    // 展开
    const expand = () => {
        if (!elRef.current) {
            return
        }

        elRef.current.classList.remove(styles.hasCollapsed)
    }

    const toggle = bool => {
        if (bool) {
            fold()
        } else {
            expand()
        }
    }

    useImperativeHandle(ref, () => ({}))

    onHandle &&
        onHandle({
            fold,
            expand,
            toggle,
            getViewRect() {
                return elRef.current.getBoundingClientRect()
            },
            getSubviewRect() {
                return subViewRef.current.getBoundingClientRect()
            }
        })

    return (
        <div ref={elRef} className={classNames(styles.container)}>
            <div ref={subViewRef} className={styles.subview}>
                {children}
            </div>
            <div className={styles.trigger}>
                <div className={styles.background} />
            </div>
            <div className={styles.wrap}>
                <div className={styles.leftLine} />
                <a className={classNames(styles.btn, styles.expandBtn)} onClick={() => onCollapse(false)}>
                    展开
                    <DownOutlined className={styles.arrow} />
                </a>
                <a className={classNames(styles.btn, styles.foldBtn)} onClick={() => onCollapse(true)}>
                    收起
                    <UpOutlined className={styles.arrow} />
                </a>
                <div className={styles.rightLine} />
            </div>
        </div>
    )
})
